/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

if (module.hot) {
    // If requested accpet HMR for the entry point
    module.hot.accept();
}

import './bootstrap';

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import {register, handlePageNotFound} from './register';
import {trackPageView} from './fn/navigation';

// Stamp this page view in the browser history so the "Zurück" buttons can tell
// whether there is an in-app page to return to (see fn/navigation.js).
trackPageView();

register('auth.login', require('./pages/auth/Login').default);
register('auth.register', require('./pages/auth/Register').default);
register('auth.passwords.reset', require('./pages/auth/passwords/Reset').default);
register('auth.passwords.email', require('./pages/auth/passwords/Email').default);

register('users.index', require('./pages/user/Index').default);
register('users.form', require('./pages/user/Form').default);

register('notifications.index', require('./pages/notification/Index').default);

register('dashboard', require('./pages/Dashboard').default);
register('file.index', require('./pages/file/Index').default);
register('file.preview', require('./pages/file/Preview').default);

register('lifeCycleRates.index', require('./pages/lifeCycle/Index').default);
register('lifeCycleRates.form', require('./pages/lifeCycle/Form').default);

register('attributes.index', require('./pages/attribute/Index').default);
register('attributes.form', require('./pages/attribute/Form').default);

register('attributeGroups.index', require('./pages/attributeGroup/Index').default);
register('attributeGroups.form', require('./pages/attributeGroup/Form').default);
register('history.show', require('./pages/history/Show').default);

register('contacts.index', require('./pages/contacts/Index').default);
register('contacts.show', require('./pages/contacts/Show').default);
register('contacts.create', require('./pages/contacts/Create').default);
register('contacts.edit', require('./pages/contacts/Edit').default);

register('customers.index', require('./pages/customers/Index').default);
register('customers.show', require('./pages/customers/Show').default);
register('customers.create', require('./pages/customers/Create').default);
register('customers.edit', require('./pages/customers/Edit').default);

register('courses.index', require('./pages/courses/Index').default);
register('courses.show', require('./pages/courses/Show').default);
register('courses.create', require('./pages/courses/Create').default);
register('courses.edit', require('./pages/courses/Edit').default);

register('persons.index', require('./pages/persons/Index').default);
register('persons.show', require('./pages/persons/Show').default);
register('persons.create', require('./pages/persons/Create').default);
register('persons.edit', require('./pages/persons/Edit').default);

register('schedules.index', require('./pages/schedules/Index').default);
register('schedules.show', require('./pages/schedules/Show').default);
register('schedules.create', require('./pages/schedules/Create').default);
register('schedules.edit', require('./pages/schedules/Edit').default);

register('participations.index', require('./pages/participations/Index').default);
register('participations.show', require('./pages/participations/Show').default);
register('participations.create', require('./pages/participations/Create').default);
register('participations.edit', require('./pages/participations/Edit').default);

register('qualifications.index', require('./pages/qualifications/Index').default);
register('qualifications.show', require('./pages/qualifications/Show').default);
register('qualifications.create', require('./pages/qualifications/Create').default);
register('qualifications.edit', require('./pages/qualifications/Edit').default);

register('machines.index', require('./pages/machines/Index').default);
register('machines.show', require('./pages/machines/Show').default);
register('machines.create', require('./pages/machines/Create').default);
register('machines.edit', require('./pages/machines/Edit').default);

register('structures.index', require('./pages/structures/Index').default);
register('structures.show', require('./pages/structures/Show').default);
register('structures.create', require('./pages/structures/Create').default);
register('structures.edit', require('./pages/structures/Edit').default);

// register('protocols.index', require('./pages/protocols/Index').default);
register('protocols.show', require('./pages/protocols/Show').default);
register('protocols.create', require('./pages/protocols/Create').default);
register('protocols.offline', require('./pages/protocols/Offline').default);

register('contracts.index', require('./pages/contracts/Index').default);
register('contracts.show', require('./pages/contracts/Show').default);
register('contracts.create', require('./pages/contracts/Create').default);
register('contracts.edit', require('./pages/contracts/Edit').default);

register('appointments.index', require('./pages/appointments/Index').default);
register('appointments.show', require('./pages/appointments/Show').default);
register('appointments.create', require('./pages/appointments/Create').default);
register('appointments.edit', require('./pages/appointments/Edit').default);

register('notes.index', require('./pages/notes/Index').default);
register('notes.show', require('./pages/notes/Show').default);
register('notes.create', require('./pages/notes/Create').default);
register('notes.edit', require('./pages/notes/Edit').default);

register('cooperations.index', require('./pages/cooperations/Index').default);
register('cooperations.show', require('./pages/cooperations/Show').default);
register('cooperations.create', require('./pages/cooperations/Create').default);
register('cooperations.edit', require('./pages/cooperations/Edit').default);

register('accounts.index', require('./pages/accounts/Index').default);
register('accounts.show', require('./pages/accounts/Show').default);
register('accounts.create', require('./pages/accounts/Create').default);
register('accounts.edit', require('./pages/accounts/Edit').default);

register('archive.index', require('./pages/archives/Index').default);

register('invoice.show', require('./pages/invoice/Show').default);
register('invoice.index', require('./pages/invoice/Index').default);

// At the end of registration we handle the case of an unmounted page load.
// This essentially means, that a laravel view without a registered
// component was loaded.
handlePageNotFound();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js